// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"s5-z","colorTextValue":"t5-z","swatches":"u5-z","collapseLink":"v5-z","isCollapsed":"w5-z","dropdown":"x5-z","disabled":"y5-z"};